import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { ThemeProvider } from "@/context/ThemeContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import AppLayout from "@/components/AppLayout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import BrandCenter from "@/pages/BrandCenter";
import MediaLibrary from "@/pages/MediaLibrary";
import AssetDetail from "@/pages/AssetDetail";
import CategoryPage from "@/pages/CategoryPage";
import AIAssistant from "@/pages/AIAssistant";
import Admin from "@/pages/Admin";
import Analytics from "@/pages/Analytics";
import Notifications from "@/pages/Notifications";
import Merchandise from "@/pages/Merchandise";
import PublicShare from "@/pages/PublicShare";
import MenuDesigner from "@/pages/MenuDesigner";
import MenuDesignerNew from "@/pages/MenuDesignerNew";
import MenuDesignerWorkspace from "@/pages/MenuDesignerWorkspace";
import PromptDialog from "@/components/PromptDialog";
import ConfirmDialog from "@/components/ConfirmDialog";
import MoveToFolderModal from "@/components/MoveToFolderModal";

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/s/:token" element={<PublicShare />} />
            <Route
              element={
                <ProtectedRoute>
                  <AppLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Dashboard />} />
              <Route path="brand" element={<BrandCenter />} />
              <Route path="products" element={<CategoryPage category="product" eyebrow="Products" title="Product Assets" description="Product photography, packaging renders, transparent PNGs, sell sheets, and COAs. Filter or upload by location — MA, NY, NYT, CAN, or GEN for anything shared across markets." />} />
              <Route path="strains" element={<CategoryPage category="strain" eyebrow="Strains" title="Strain Library" description="Strain-specific imagery, hero shots, and lifestyle photography. Filter or upload by location — MA, NY, NYT, CAN, or GEN for anything shared across markets." />} />
              <Route path="artwork" element={<CategoryPage category="artwork" eyebrow="Print & Proofs" title="Artwork" description="Product artwork and print proofs. Filter or upload by location — MA, NY, NYT, CAN, or GEN for anything shared across markets." />} />
              <Route path="marketing" element={<CategoryPage category="marketing" eyebrow="Marketing" title="Marketing Assets" description="Social graphics, campaign creative, photography, banners, and video." />} />
              <Route path="menus" element={<Navigate to="/retail" replace />} />
              <Route path="retail" element={<CategoryPage category="retail" eyebrow="Retail" title="Retail Toolkit" description="Shelf talkers, counter cards, signage, and installation guides." />} />
              <Route
                path="sales"
                element={
                  <ProtectedRoute roles={["admin"]}>
                    <CategoryPage category="sales" eyebrow="Wholesale" title="Wholesale Toolkit" description="Pricing sheets, decks, and competitive tools. Restricted to the admin team." />
                  </ProtectedRoute>
                }
              />
              <Route path="library" element={<MediaLibrary />} />
              <Route path="merch" element={<Merchandise />} />
              <Route path="menu-designer" element={<MenuDesigner />} />
              <Route path="menu-designer/new" element={<MenuDesignerNew />} />
              <Route path="menu-designer/edit/:id" element={<MenuDesignerWorkspace />} />
              <Route path="assets/:id" element={<AssetDetail />} />
              <Route path="assistant" element={<AIAssistant />} />
              <Route path="notifications" element={<Notifications />} />
              <Route path="analytics" element={<ProtectedRoute roles={["admin"]}><Analytics /></ProtectedRoute>} />
              <Route path="admin" element={<ProtectedRoute roles={["admin"]}><Admin /></ProtectedRoute>} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <PromptDialog />
          <ConfirmDialog />
          <MoveToFolderModal />
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
